module.exports = __webpack_public_path__ + "img/kong.e043d0db.png";